// Rows rendered per page in a log step's Summary and Response tabs (see OutputLogViewer.jsx).
export const logStepOutputPageSize = 20;
